import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useProject } from '../context/ProjectContext';
import PremiumGate from './PremiumGate';

const PremiumRoute = ({ children, title }) => {
  const { hasActivePlan } = useAuth();
  const { currentProject } = useProject();
  const isPremium = hasActivePlan ? hasActivePlan() : false;

  // Demo projects are viewable by everyone
  if (currentProject?.is_demo) {
    return children;
  }

  if (!isPremium) {
    return <PremiumGate title={title} />;
  }

  return children;
};

export default PremiumRoute;
